<template>
  <div>
    <el-dialog
      :title="dataForm.Id ? '编辑' : '新增'"
      :visible.sync="visible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item label="名称" prop="Name">
          <el-input v-model="dataForm.Name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="CRM域名" prop="CrmUrl">
          <el-input
            v-model="dataForm.CrmUrl"
            placeholder="请输入CRM域名"
          ></el-input>
        </el-form-item> 
        <el-form-item label="备注" prop="Remark">
          <el-input
            v-model="dataForm.Remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-switch v-model="dataForm.Status" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="ok"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      dataForm: {
        Id: "",
        Name: "", //名称
        CrmUrl: "", //crm域名
        Status: true,
        Remark: "",
      },
      rules: {
        Name: { required: true, message: "请输入名称", trigger: "change" },
        CrmUrl: {
          required: true,
          message: "请输入CRM域名地址",
          trigger: "change",
        },
      },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      if (id) {
        this.dataForm.Id = id;
        this.$http({
          url: "/api/TenantManager/GetInfo/" + this.dataForm.Id,
          method: "get",
        }).then((res) => {
          this.dataForm.Name = res.data.response.Name; //名称
          this.dataForm.CrmUrl = res.data.response.CrmUrl; //名称
          this.dataForm.Remark = res.data.response.Remark; //备注
          this.dataForm.Status = res.data.response.Status; //状态
        });
      }
    },
    handleClose() {
      this.$refs.dataForm.resetFields();
      this.visible = false;
      this.dataForm.Id = "";
    },
    ok() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: !!this.dataForm.Id
              ? "/api/TenantManager/Put"
              : "/api/TenantManager/Post",
            method: !!this.dataForm.Id ? "put" : "post",
            data: this.dataForm,
          })
            .then((res) => {
              if (res.data && res.data.success) {
                this.confirmLoading = false;
                console.log(res);
                this.$message.success(res.data.msg);
                this.handleClose();
                this.$emit("ok");
              }
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>